import PropTypes from "prop-types";
import {ChangeEvent, useEffect, useState} from "react";
import {Button, Form, FormGroup, FormText, Input, Label} from "reactstrap";
import {useAppState} from "../../context/state";
import {useNavigate} from "react-router-dom";
import {clone, set as objectSet} from "lodash";
import {loginSchema} from "./auth_schema";
import {useValidateForm} from "../../global/callback functions/forms/validate/validate";
import {fbLogin} from "./fb_signIn";
import PageWrapper from "../../layouts/components/PageContainer";
import {getAuth} from "firebase/auth";

LoginUser.propTypes = {
  setExistingUser: PropTypes.func,
};

LoginUser.defaultProps = {};

export default function LoginUser() {
  const {setAppState} = useAppState();
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({username: "", password: ""});
  const {errors, handleFormSubmit, reValidate} = useValidateForm(
    loginSchema,
    formValues,
  );

  const [authError, setAuthError] = useState<string>("");
  const [submitAttempted, setSubmitAttempted] = useState(false);

  useEffect(() => {
    reValidate();
  }, [reValidate]);

  function setProcessing(state: boolean) {
    setAppState((old) => ({
      ...old,
      processing: state,
    }));
  }

  function handleFieldChange({
                               target: {name, value},
                             }: ChangeEvent<HTMLInputElement>) {
    setAuthError("");
    const newFormValues = clone(formValues);
    objectSet(newFormValues, name.split("."), value);
    setFormValues(newFormValues);
  }

  return (
    <PageWrapper>
      <div style={{maxWidth: "600px", margin: "auto"}}>
        <Form
          onSubmit={(event) => {
            event.preventDefault();
            setSubmitAttempted(true);

            handleFormSubmit(async (data) => {
              setAuthError("");
              setProcessing(true);

              try {
                await fbLogin(data);

                const auth = getAuth();
                if (!auth.currentUser) {
                  setAuthError("Feil brukernavn eller passord");
                  return;
                }

                navigate("/admin");
              } catch (e: any) {
                setAuthError("Feil brukernavn eller passord");
              } finally {
                setProcessing(false);
              }
            });
          }}>
          <FormGroup>
            <Label className={"required"} htmlFor={"username"}>
              Epost / mobilnummer
            </Label>
            <Input
              name={"username"}
              type="text"
              placeholder=""
              onChange={handleFieldChange}
              required
              invalid={submitAttempted && (!!errors?.username || !!authError)}
            />
            {errors?.username && (
              <FormText className={"form-error"}>{errors.username}</FormText>
            )}
          </FormGroup>

          <FormGroup>
            <Label className={"required"} htmlFor={"password"}>
              Passord
            </Label>
            <Input
              name={"password"}
              type="password"
              onChange={handleFieldChange}
              required
              invalid={submitAttempted && (!!errors?.password || !!authError)}
            />
            {errors?.password ? (
              <FormText className={"form-error"}>{errors.password}</FormText>
            ) : submitAttempted && authError ? (
              <FormText className={"form-error"}>{authError}</FormText>
            ) : null}
          </FormGroup>

          <FormGroup className={"form_action"}>
            <Button className={"form-action loginBtn"} type="submit">
              Login
            </Button>
          </FormGroup>
        </Form>
      </div>
    </PageWrapper>
  );
}
